import Seo from '../components/Seo';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import InitialsAvatar from '../components/InitialsAvatar';
import { PageLoader, ErrorState, EmptyState } from '../components/ui';
import { useAsync } from '../lib/useAsync';
import { clubsApi } from '../api/resources';

function ClubCard({ club }) {
  const president = club.president;
  return (
    <article className="card card-hover flex h-full flex-col p-6">
      <h2 className="font-display text-xl font-bold leading-snug text-ink">{club.name}</h2>

      <div className="mt-5 flex items-center gap-4">
        {president ? (
          <>
            <div className="h-14 w-14 shrink-0 overflow-hidden rounded-full ring-2 ring-maroon-50 shadow-card">
              <InitialsAvatar
                name={president.full_name}
                photoPath={president.photo_url}
                size="sm"
              />
            </div>
            <div className="min-w-0">
              <p className="truncate font-display font-semibold text-ink">{president.full_name}</p>
              <p className="text-[0.7rem] font-semibold uppercase tracking-[0.12em] text-maroon-700">
                President
              </p>
            </div>
          </>
        ) : (
          <div className="flex items-center gap-4 text-ink-muted">
            <div
              aria-hidden="true"
              className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-maroon-50 font-display text-lg font-bold text-maroon-300"
            >
              ?
            </div>
            <p className="text-sm italic">President to be announced</p>
          </div>
        )}
      </div>

      <div className="mt-auto pt-6">
        <span className="pill-gold">
          {club.members_count} {club.members_count === 1 ? 'member' : 'members'}
        </span>
      </div>
    </article>
  );
}

export default function Clubs() {
  const { data: clubs, loading, error, reload } = useAsync(() => clubsApi.list(), []);
  const items = clubs || [];

  return (
    <>
      <Seo
        title="Member Clubs"
        description="Explore the member clubs of Zonta District 17 Area 1 — each rooted in its local community, led by a dedicated president and united by a shared mission."
      />

      <PageHero
        eyebrow="Our Network"
        title="Member clubs across the Area"
        subtitle="A network of vibrant clubs, each rooted in its local community and united by our shared mission to empower women and girls."
        image="/img/give-heart.jpg"
      />

      <section className="section">
        <div className="container-page">
          {loading ? (
            <PageLoader label="Loading clubs…" />
          ) : error ? (
            <ErrorState error={error} onRetry={reload} />
          ) : !items.length ? (
            <EmptyState
              title="No clubs to show yet"
              message="Our club directory is being updated. Please check back soon."
            />
          ) : (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {items.map((club, i) => (
                <Reveal key={club.name} delay={(i % 3) * 90}>
                  <ClubCard club={club} />
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
